import { useMemo } from 'react';
import useCheckoutState from './useCheckoutState';
import useSelectedPrice from './useSelectedPrice';

/**
 * Resolve the effective setup fee (and `setupFeeMultipliesWithQuantity`) for the
 * current checkout.
 *
 * For a multi-price product the fee comes from the selected price subdoc — the
 * same price `useProductPrice` charges — so the displayed and billed setup fee
 * track the buyer's selection. Returns 0 when a multi-price product has no
 * selection yet. Legacy products (no `prices[]`) fall back to the product-level
 * fields.
 *
 * @returns {{ setupFee: number, setupFeeMultipliesWithQuantity: boolean }}
 */
export default function useSetupFee() {
  const { product } = useCheckoutState();
  const selectedPrice = useSelectedPrice();

  return useMemo(() => {
    const isMultiPrice = Array.isArray(product?.prices) && product.prices.length > 0;
    // TODO(M14): legacy product-level setupFee fallback — remove after the prices[] backfill migration
    const source = isMultiPrice ? selectedPrice : product;
    return {
      setupFee: Number(source?.setupFee || 0),
      setupFeeMultipliesWithQuantity: !!source?.setupFeeMultipliesWithQuantity,
    };
  }, [product, selectedPrice]);
}
